import { z } from 'zod';
const str = z.string().min(1).max(2000);
const strList = z.array(z.string().min(1).max(200)).max(32);
const num = z.number().int().min(0).max(1_000_000);
export const PLAN_PATCH_FIELD_REGISTRY = {
    'objective.primaryGoal': {
        path: 'objective.primaryGoal',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: z.enum([
            'lead_generation',
            'appointment_generation',
            'awareness',
            'traffic',
            'conversion',
            'retention',
            'other',
        ]),
    },
    'objective.description': {
        path: 'objective.description',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: str,
    },
    'audience.description': {
        path: 'audience.description',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: str,
    },
    'audience.industries': {
        path: 'audience.industries',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace', 'add', 'remove'],
        valueSchema: strList,
    },
    'audience.locations': {
        path: 'audience.locations',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace', 'add', 'remove'],
        valueSchema: strList,
    },
    'audience.companySize': {
        path: 'audience.companySize',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: z.object({
            min: z.number().int().min(0).optional(),
            max: z.number().int().min(0).optional(),
        }),
    },
    'audience.jobRoles': {
        path: 'audience.jobRoles',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace', 'add', 'remove'],
        valueSchema: strList,
    },
    'audience.exclusions': {
        path: 'audience.exclusions',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace', 'add', 'remove'],
        valueSchema: strList,
    },
    'audience.existingAudienceId': {
        path: 'audience.existingAudienceId',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace', 'remove'],
        valueSchema: z.string().uuid(),
    },
    'acquisition.required': {
        path: 'acquisition.required',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: z.boolean(),
    },
    'acquisition.method': {
        path: 'acquisition.method',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: z.enum(['existing_leads', 'scrape', 'import', 'mixed']),
    },
    'acquisition.estimatedLeadCount': {
        path: 'acquisition.estimatedLeadCount',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: num,
    },
    'campaign.offer': {
        path: 'campaign.offer',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: str,
    },
    'campaign.callToAction': {
        path: 'campaign.callToAction',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: str,
    },
    'campaign.channel': {
        path: 'campaign.channel',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: z.enum(['email', 'multi_channel', 'other']),
    },
    'campaign.estimatedVolume': {
        path: 'campaign.estimatedVolume',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: num,
    },
    'campaign.objective': {
        path: 'campaign.objective',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: str,
    },
    'messaging.valueProposition': {
        path: 'messaging.valueProposition',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: str,
    },
    'messaging.coreMessage': {
        path: 'messaging.coreMessage',
        kind: 'decision',
        requiresConfirmation: true,
        allowedOperations: ['replace'],
        valueSchema: str,
    },
};
export function isAllowedPatchPath(path) {
    return path in PLAN_PATCH_FIELD_REGISTRY;
}
export function validatePatchFieldValue(path, value) {
    const def = PLAN_PATCH_FIELD_REGISTRY[path];
    if (!def)
        return { ok: false, error: `unknown_path:${path}` };
    const parsed = def.valueSchema.safeParse(value);
    if (!parsed.success)
        return { ok: false, error: `invalid_type:${path}` };
    return { ok: true, value: parsed.data };
}
//# sourceMappingURL=patchRegistry.js.map